import {Component, OnInit, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ApiService} from '../../../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {UtilsService} from '../../../../core/services/utils/utils.service';
import {Router} from '@angular/router';
import {DashboardService} from '../../../../dashboard/dashboard.service';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {SharedServiceService} from '../../../../core/services/shared-service.service';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
    selector: 'app-image-uploader-modal',
    templateUrl: './image-uploader-modal.component.html',
    styleUrls: ['./image-uploader-modal.component.css'],
    standalone: false
})
export class ImageUploaderModalComponent implements OnInit {

  // IMAGE UPLOAD
  modalRef: BsModalRef;
  imageChangedEvent: any = '';
  croppedFile: any;
  aspectRatio = 1;
  url = '';
  loading = false;
  progress = 0;

  constructor(
    private api: ApiService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private utils: UtilsService,
    private router: Router,
    private shared: SharedServiceService,
    private httpClient: HttpClient
  ) {
  }

  ngOnInit(): void {
  }

  // IMAGE CROPPER
  fileChangeEvent(event: any): void {
    this.aspectRatio = 1;
    this.imageChangedEvent = event;
  }

  uploadImage(e): any {
    e.preventDefault();
    if (!this.croppedFile) {
      this.utils.toastError('Upload image');
      return false;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append('file', this.croppedFile, this.croppedFile?.name || `upload-${Date.now()}.png`);
    const upload = this.httpClient.post<any>('file-upload', formData, {
      reportProgress: true,
      observe: 'events'
    });
    upload.subscribe(
      (res: any) => {
        if (res.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((res.loaded / res.total) * 100);
        } else if (res.type === HttpEventType.Response) {
          this.loading = false;
          this.url = res.body.response.url;
          this.progress = 0;
          this.copyToClipboard();
        }
      },
      (err) => {
        this.loading = false;
        this.utils.resErr(err);
      }
    );
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedFile = new File([base64ToFile(event.base64)], `${Date.now()}.png`);
  }

  loadImageFailed(): void {
    this.utils.toastError('Image Load failed!');
  }

  closeModal(): void {
    this.shared.dispatchEmitter('closeModal', {});
  }

  copyToClipboard(): void {
    this.utils.copyToClipboard(this.url);
    this.utils.toastSuccess('Image link copied to your clipboard');
  }

  UploadNewImage(): void {
    this.imageChangedEvent = '';
    this.croppedFile = '';
    this.url = '';
    this.loading = false;
    this.progress = 0;
    const ele = document.getElementById('img_upload');
    if (!!ele) {
      ele.click();
    }
  }
}
